import React from "react";

const LinkedlnSVG = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.959 14.2189V21.5979H17.681V14.7129C17.681 12.9829 17.062 11.8029 15.514 11.8029C14.332 11.8029 13.628 12.5989 13.319 13.3679C13.206 13.6429 13.177 14.0259 13.177 14.4109V21.5979H8.897C8.897 21.5979 8.955 9.93788 8.897 8.72888H13.177V10.5529L13.149 10.5949H13.177V10.5529C13.745 9.67788 14.76 8.42688 17.033 8.42688C19.848 8.42688 21.959 10.2669 21.959 14.2189ZM4.421 2.52588C2.958 2.52588 2 3.48588 2 4.74888C2 5.98388 2.93 6.97288 4.365 6.97288H4.393C5.886 6.97288 6.813 5.98388 6.813 4.74888C6.787 3.48588 5.887 2.52588 4.422 2.52588H4.421ZM2.254 21.5979H6.532V8.72888H2.254V21.5979Z"
        fill="#0F172A"
      />
    </svg>
  );
};

export default LinkedlnSVG;
